
// src/actions/home-sub-diaries.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_HOME_SUB_DIARIES = "FETCH_HOME_SUB_DIARIES"
export const FETCH_HOME_SUB_DIARIES_REQUESTED = "FETCH_HOME_SUB_DIARIES_REQUESTED"
export const FETCH_HOME_SUB_DIARIES_COMPLETED = "FETCH_HOME_SUB_DIARIES_COMPLETED"
export const FETCH_HOME_SUB_DIARIES_FAILED = "FETCH_HOME_SUB_DIARIES_FAILED"

export function fetchHomeSubDiariesRequested() {
  return {
    type: FETCH_HOME_SUB_DIARIES_REQUESTED
  }
}

// conditions:
//   diary_ids: 投稿idのリスト
export function fetchHomeSubDiaries(offset, conditions = {}) {
  return function(dispatch) {
    dispatch(fetchHomeSubDiariesRequested())
    conditions = Object.assign(conditions, { offset })
    return api.get(`/home_diaries`, conditions)
        .then((results)=> {
          dispatch(fetchHomeSubDiariesCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchHomeSubDiariesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchHomeSubDiariesCompleted(results, offset) {
  return {
    type: FETCH_HOME_SUB_DIARIES_COMPLETED,
    results, offset
  }
}

export function fetchHomeSubDiariesFailed(error) {
  return {
    type: FETCH_HOME_SUB_DIARIES_FAILED,
    error,
  }
}

export const FETCH_HOME_SUB_USER_DIARIES = "FETCH_HOME_SUB_USER_DIARIES"
export const FETCH_HOME_SUB_USER_DIARIES_REQUESTED = "FETCH_HOME_SUB_USER_DIARIES_REQUESTED"
export const FETCH_HOME_SUB_USER_DIARIES_COMPLETED = "FETCH_HOME_SUB_USER_DIARIES_COMPLETED"
export const FETCH_HOME_SUB_USER_DIARIES_FAILED = "FETCH_HOME_SUB_USER_DIARIES_FAILED"

export function fetchHomeSubUserDiariesRequested() {
  return {
    type: FETCH_HOME_SUB_USER_DIARIES_REQUESTED
  }
}

export function fetchHomeSubUserDiaries(offset, user_id) {
  return function(dispatch) {
    dispatch(fetchHomeSubUserDiariesRequested())
    return api.get(`/home_diaries/users/${user_id}`, { offset })
        .then((results)=> {
          dispatch(fetchHomeSubUserDiariesCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchHomeSubUserDiariesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchHomeSubUserDiariesCompleted(results, offset) {
  return {
    type: FETCH_HOME_SUB_USER_DIARIES_COMPLETED,
    results, offset
  }
}

export function fetchHomeSubUserDiariesFailed(error) {
  return {
    type: FETCH_HOME_SUB_USER_DIARIES_FAILED,
    error,
  }
}

export const SEARCH_HOME_DIARIES = "SEARCH_HOME_DIARIES"
export const SEARCH_HOME_DIARIES_REQUESTED = "SEARCH_HOME_DIARIES_REQUESTED"
export const SEARCH_HOME_DIARIES_COMPLETED = "SEARCH_HOME_DIARIES_COMPLETED"
export const SEARCH_HOME_DIARIES_FAILED = "SEARCH_HOME_DIARIES_FAILED"

export function searchHomeDiariesRequested() {
  return {
    type: SEARCH_HOME_DIARIES_REQUESTED
  }
}

// conditions:
//   user_ids: ユーザidのリスト
//   category: 投稿種別(diary, memo, kpi)
//   start_date, end_date: 投稿日の期間指定
//   files_attached: 添付ファイルがあるものに限定
//   query: 検索キーワード
export function searchHomeDiaries(offset, conditions = {}) {
  return function(dispatch) {
    dispatch(searchHomeDiariesRequested())
    conditions = Object.assign(conditions, { offset })
    return api.get(`/home_diaries/search`, conditions)
        .then((results)=> {
          dispatch(searchHomeDiariesCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(searchHomeDiariesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function searchHomeDiariesCompleted(results, offset) {
  return {
    type: SEARCH_HOME_DIARIES_COMPLETED,
    results, offset
  }
}

export function searchHomeDiariesFailed(error) {
  return {
    type: SEARCH_HOME_DIARIES_FAILED,
    error,
  }
}




// WEBPACK FOOTER //
// ./src/actions/home-sub-diaries.js